<template>
  <div class="vcode flex" style="margin-bottom: 0; width: 100%">
    <div class="login_formItem drapWrap" style="margin-bottom: 0">
      <div id="drag" style="color: rgb(241, 107, 107)">
        <div class="drag_bg"></div>
        <div class="drag_text" onselectstart="return false;" unselectable="on">
          向右滑动验证
        </div>
        <div class="handler handler_bg"></div>
      </div>
      <div class="verifyCodeWrap" style="display: none">
        <div class="verifyCloseWrap">
          <p class="verifyCodeTitle">拖动下方图片完成拼图</p>
          <div class="verifyClose"></div>
        </div>
        <div class="verifyCode">
          <img alt class="slideImg" src />
          <img alt class="bottomImg" src />
        </div>
      </div>
    </div>
    <input type="hidden" id="verifyX" />
  </div>
</template>

<script>
import { verify } from "@/assets/js/verifyCode";
import $ from "jquery";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.verify();
    $("#verifyX").val("");
    $("#drag").removeClass("yanzhengOk");
  },
  methods: {
    verify() {
      verify();
    },
  },
};
</script>

<style>
.login_formItem {
  align-items: center;
  height: 60px;
  width: 100%;
  line-height: 60px;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #c1c1c1;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.login_formItem img {
  width: 18px;
  height: 20px;
  margin: 0 20px 0 12px;
}
.login_formItem input {
  width: 360px;
  height: 100%;
  line-height: 60px;
}
.login_formItem .loginVcode {
  width: 240px;
  height: 100%;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #c1c1c1;
  box-sizing: border-box;
}
.login_formItem .loginVcode input {
  width: 185px;
}

#drag {
  position: relative;
  background-color: #fafafa;
  width: 100%;
  height: 100%;
  text-align: center;
}
#drag .handler {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 60px;
  height: 100%;
  border: 1px solid #293787;
  cursor: move;
  background-color: #293787;

  box-sizing: border-box;
}
.handler_bg {
  background: #fff
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAA50lEQVQ4T72VQVLCQBBFX1+BE3gGFFmCHsS7cQxg50UI4MqyLEv2fGpCg6TITKZkQhZZ/Xp5mfTvmKQBsDezHxJXbi4gTNICeABezewjxs3NnaBjYA58psCSsnI1NNwkPQPB+At4MbNtm3FuroaWBp+hDn4ClsC3G28ixslcA1oKfAV18KMbhzELZ7yOGLfmWqG3gqNQBw/d+NeNq4hxM5dqkYPfgBnwbmaTRDn+ch3VPBns3HTVYXrMJZ78v1c3q+7z9SXdNE7n7l9UtWyjJBUB9relJI18wMPam8YWdW6u181f/B91AEdE8A+uCCl5AAAAAElFTkSuQmCC")
    no-repeat center;
}

#drag .handler_Nook_bg {
  background: #f16b6b;
  border-color: #f16b6b;
}
#drag .drag_bg {
  background-color: #293787;
  height: 100%;
  width: 0px;
}
#drag .drag_no_bg {
  background-color: #fce1e1;
  height: 100%;
}
.verifer_cuo {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -7px;
  margin-top: -7px;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAvklEQVQ4T52SvRHCMAxGnwqPACtQsAAN3MEeLMAUyRAwAOwBBTNQZAXYwC7EyWfnkuDkjqiU9KRPP+K9boCjc1Qi8mHCVHURAhVwE+/1DJyAl3Psx+AEPYA1cJGBowgXc0yZqi5D4J6q9eACdBCRt+SRSrDFQiDLs4IRMn8Lps42fE5sUtFVmr+FfsAO/AQMMGucY5c7ZYW9jhPgdrjtf6T2TtVdTne+uNnCclo4glO3HIvNf4DZLzfjyWvg+gXymKeZUiUS0wAAAABJRU5ErkJggg==")
    no-repeat center;
}
.verifer_dui {
  width: 22px;
  height: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -11px;
  margin-top: -8px;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAABX0lEQVQ4T7WTvyvFYRjFPycxWEwyq7spRqVIDGJQwiRlMBjYJP4CzEwGJSSLSVmkDJTBcq2YTEhJKMvRo/fKj6/vVa5nfHufz/uc55xX/FOpUlzbNcAO0Aw0VQRsOzjrwAhwDRQqBV4EZoB7oENS8c9g27PAPPAC9Eo6iPX+CWw7pMcKokYlbZY8ewPbngCKko5/a6btLmAPCNOmJC1/7JXtRuASeAb6Je2Xg9tuBUJyLbAgae5rT2niJWASeAL6JB3+BLddAEJZPRDSYwX+CRwPrADjwCPQI+no62XbAQtowHeBQUlh2rd6Ny9lcRUYS7EJ+Empw3YdEEpagDjvkhQKM+tTKmxXAWsp6JHJbkmn6VeFUWHYOdAm6SbPi29xS/AtYBi4CzgwnR67AjolXZQzODPHtquBbWAgBT8iFQraJZ2Vg+Z+kCR/I01+CwzlpSUzFXkT2G4AHvKMyup/BVwjeSU7BBjMAAAAAElFTkSuQmCC")
    no-repeat center;
}

#drag .drag_text {
  position: absolute;
  top: 0px;
  width: 100%;
  font-size: 14px;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
  box-sizing: border-box;
  height: 60px;
  line-height: 60px;
  color: #999;
}
#drag .drag_no_text {
  border-color: #f16b6b;
}
.yanzhengOk {
  background-color: #293787 !important;
  line-height: 55px;
  font-size: 14px;
  color: #fff;
}
.yanzhengOkItem {
  color: #fff;
}
.yanzhengOkItem img {
  margin-right: 6px;
}

.verifyCode {
  width: 100%;
  height: 160px;
  position: relative;
}
.verifyCodeWrap {
  width: 410px;
  position: absolute;
  top: -240px;
  left: 0;
  background-color: #fff;
  -moz-box-shadow: 0px 0px 5px #eeeeee;
  -webkit-box-shadow: 0px 0px 5px #eeeeee;
  box-shadow: 0px 0px 5px #eeeeee;
  padding: 0 20px;
  border-radius: 10px;
  padding-bottom: 20px;
  display: none;
}
.verifyCodeTitle {
  line-height: 46px;
  font-size: 15px;
  color: #666666;
}
.verifyCode img {
  display: block;
  width: 100%;
  height: 100%;
}
.verifyCode .slideImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 55px;
  height: 45px;
}
.handler_bg {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
			not supported by any browser */
}

.loginFormMain .mainItem.drapWrap {
  margin-bottom: 0;
  height: 55px;
  position: relative;
}
.drapWrap {
  position: relative;
}
.drapWrap img {
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
}

.drapWrap .yanzhengOkItem img {
  margin-right: 6px !important;
}
.login_formItem.drapWrap {
  border: none;
}
.verifyCloseWrap {
  position: relative;
}
.verifyClose {
  width: 14px;
  height: 14px;
  display: block;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -7px;
  cursor: pointer;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAA20lEQVQoU43SsQ6CMBAGYC9GFhfgZdyMi4kPYONgWLnJl3GjK9HBvoAJk3HyZYDFQDRpzREhpbRKN5p+3N3fAmNsGobhOkmS62TEQsRNnucZMMY83/dPAHDnnB9/WUQ8SCmXZVnugQ6OwToSQrwa+A+biM530IVtaABNDACqnYna0+fvVdTbDoLgQd9FUSxMZK1Im9SeUmr1/dHNlvagoj4TQddV9aAtCNdVddCVHlWN43imlDrrj6SBiLiVUu7oRdiCMPCFcy4aGEXRvK7rtwu1aVPlqqq8NE2fH6LTtBWYuhzzAAAAAElFTkSuQmCC");
  background-size: 100% 100%;
}
</style>